import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone, User } from "lucide-react";
import { COMPANY } from "@/lib/site";

const LINKS = [
  { to: "/", label: "Accueil", end: true },
  { to: "/services", label: "Services & Tarifs" },
  { to: "/flotte", label: "Notre Flotte" },
  { to: "/contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => setOpen(false), [location.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-300 ${
        scrolled ? "bg-ink/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex flex-col leading-none">
          <span className="font-serif text-xl md:text-2xl tracking-wide text-white">
            GOLDEN <span className="gold-text">CAB</span>
          </span>
          <span className="text-[10px] tracking-[0.35em] text-white/50 mt-0.5">TRANSPORT</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`nav-${l.label.split(" ")[0].toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors duration-200 ${
                  isActive ? "text-gold" : "text-white/70 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <Link
            to="/membre"
            data-testid="header-member-link"
            className="flex items-center gap-2 text-sm text-white/70 hover:text-gold transition-colors"
          >
            <User size={16} /> Espace Membre
          </Link>
          <Link
            to="/reservation"
            data-testid="header-book-btn"
            className="rounded-full bg-gold px-6 py-2.5 text-sm font-medium text-black transition-colors duration-300 hover:bg-goldsoft"
          >
            Réserver
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-ink/95 backdrop-blur-xl border-t border-white/10 px-5 py-6 space-y-2">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) =>
                `block py-3 text-base border-b border-white/5 ${isActive ? "text-gold" : "text-white/80"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/membre" data-testid="mobile-member-link" className="block py-3 text-base border-b border-white/5 text-white/80">
            Espace Membre
          </Link>
          <Link
            to="/reservation"
            data-testid="mobile-book-btn"
            className="mt-4 block rounded-full bg-gold px-6 py-3 text-center text-base font-medium text-black"
          >
            Réserver Maintenant
          </Link>
        </div>
      )}
    </header>
  );
};
